export function ErrorBox({ onRetry }) {
  const container = {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "var(--bg)",
    padding: "24px",
  };

  const card = {
    width: "100%",
    maxWidth: "420px",
    background: "var(--paper)",
    borderRadius: "var(--radius-lg)",
    boxShadow: "var(--shadow)",
    padding: "32px 28px",
    textAlign: "center",
  };

  const badge = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    background: "var(--accent-soft)",
    marginBottom: "16px",
  };

  const title = {
    margin: "0 0 8px",
    fontSize: "20px",
    color: "var(--ink)",
    fontWeight: 800,
  };

  const desc = {
    margin: "0 0 16px",
    color: "var(--ink-soft)",
    fontSize: "15px",
    lineHeight: 1.5,
  };

  const hint = {
    margin: "10px 0 0",
    color: "var(--ink-soft)",
    fontSize: "12px",
  };

  const button = {
    display: "inline-block",
    marginTop: "6px",
    padding: "11px 22px",
    borderRadius: "999px",
    border: "none",
    background: "var(--accent)",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: 700,
    cursor: "pointer",
  };

  return (
    <div style={container} role="alert" aria-live="polite">
      <div style={card}>
        <div style={badge} aria-hidden>
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
            <path d="M12 8v5" stroke="#0F6B5C" strokeWidth="2" strokeLinecap="round" />
            <circle cx="12" cy="17" r="1.2" fill="#0F6B5C" />
            <path d="M12 3L1.5 20h21L12 3z" stroke="#0F6B5C" strokeWidth="1.5" fill="none" />
          </svg>
        </div>

        <h2 style={title}>Ops!</h2>
        <p style={desc}>
          Houve um erro ao buscar as perguntas. Entre em contato com o TI do hospital.
        </p>

        {onRetry ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <button style={button} onClick={onRetry}>
              Tentar novamente
            </button>
          </div>
        ) : null}

        <p style={hint}>
          Código: <strong>ERR_FETCH_QUESTIONS</strong>
        </p>
      </div>
    </div>
  );
}